import {Component, h} from 'preact';
import {formatNumber} from "../../utils/number";
import axios from 'axios';
import {handleAjustIpotekaClick} from "../popup/Popup";

const SEND_OFFER_URL = "https://api-public.fin.cian.ru/widgets/marketplace-offers/v0/offers/selected?utm_source=widget_web";

class OfferCard extends Component {
    sendOffer() {
        if (!this.props.offer.submitted) {
            this.state = {sent: false};
            let selectedOffice;
            if(this.props.offer.bank === 'bank-vtb') {
                selectedOffice = {
                    id: '2626',
                    code: '2626',
                    name: 'ДО № 39 «Московский, 6»',
                    address: 'г Санкт-Петербург, пр-кт Московский, д 6 литер а',
                    email: 'isp_accr_do39@spb.vtb24.ru',
                    phone: '88001002424',
                    geoLon: '30.3180319',
                    geoLat: '59.9246647',
                    kladrId: '7800000000008520040',
                    place: 'Санкт-Петербург'
                };
            }
            axios.post(SEND_OFFER_URL, {
                amount: this.props.offer.amount,
                bankId: this.props.offer.bank,
                initialPayment: this.props.offer.initialPayment,
                offerId: this.props.offer.offerId,
                seqno: this.props.offer.seqNo,
                term: this.props.offer.term,
                userId: this.props.offer.userId,
                selectedOffice
            }, {withCredentials: true}).then(() => this.setState({sent: true})).then(() => {
                axios.post("https://widget-statistics.fin.cian.ru/widgets/events/finance-widget-offers-on-card", {name: "posted"}, {withCredentials: true});
            });
        }
    }

    render({offer, id}) {
        const extraSmall = document.body.clientWidth <= 412;

        return (
            <div className={'fw-offers_offercard'}>
                <div
                    className={'fw-offers_offercard_bank' + (offer.submitted || this.state.sent ? " fw-offers_offercard_bank_ok" : "")}>
                    <img className={'fw-offers_offercard_bank_icon'} src={offer.iconHref}/>
                    <div className={'fw-offers_offercard_bank_name'}>{offer.bankName}</div>
                    {offer.submitted ?
                        <a className={'fw-offers_offercard_offer'}
                           href={"https://www.cian.ru/cf/offer-selector"}
                           target={"_blank"}
                           onClick={handleAjustIpotekaClick}
                        >Подробнее</a>
                        :
                        <div className={'fw-offers_offercard_offer'}
                             onClick={() => this.sendOffer()}
                        >Оформить</div>
                    }
                </div>
                {
                    this.state.sent ?
                        <div className={'fw-offers_offercard_detail_container_submit_ok'}>
                            <div className={'fw-offers_offercard_detail_submit_ok'}>Готово! Заявка отправлена.</div>
                            <div className={'fw-offers_offercard_detail_submit_ok'}>Скоро с вами свяжется специалист
                                банка
                            </div>
                            <div className={'fw-offers_offercard_detail_submit_ok_info'}>
                                На обработку ваших данных нужно время обычно это хватает от 2х до 8ми часов Покачто
                                мы
                                не
                                передаем информацию о объекте в банк, но сохраняем объявление в избранном
                            </div>
                        </div>
                        :
                        extraSmall ?
                            <div className={'fw-offers_offercard_detail_container'}>
                                <div className={'fw-offers_offercard_detail_item'}>
                                    <div className={'fw-offers_offercard_detail_item_title'}>Сумма кредита</div>
                                    <div
                                        className={'fw-offers_offercard_detail_value'}>{formatNumber(offer.amount)} Р
                                    </div>
                                </div>
                                <div className={'fw-offers_offercard_detail_item'}>
                                    <div className={'fw-offers_offercard_detail_item_title'}>Ставка</div>
                                    <div className={'fw-offers_offercard_detail_value'}>
                                        {formatNumber(Math.round(offer.rate * 100 * 100) / 100)}%
                                    </div>
                                </div>
                                <div className={'fw-offers_offercard_detail_item'}>
                                    <div className={'fw-offers_offercard_detail_item_title'}>Срок</div>
                                    <div
                                        className={'fw-offers_offercard_detail_value'}>{formatNumber(Math.round(offer.term / 12))} лет
                                    </div>
                                </div>
                                <div className={'fw-offers_offercard_detail_item'}>
                                    <div className={'fw-offers_offercard_detail_item_title'}>Платеж</div>
                                    <div
                                        className={'fw-offers_offercard_detail_value'}>{formatNumber(Math.round(offer.monthlyPayment))} Р/мес
                                    </div>
                                </div>
                            </div>
                            :
                            <div className={'fw-offers_offercard_detail_container'}>
                                <div className={'fw-offers_offercard_detail_item'}>
                                    <div
                                        className={'fw-offers_offercard_detail_value'}>{formatNumber(offer.amount)} Р
                                    </div>
                                    <div className={'fw-offers_offercard_detail_item_title'}>Сумма кредита</div>
                                </div>
                                <div className={'fw-offers_offercard_detail_item'}>
                                    <div className={'fw-offers_offercard_detail_value'}>
                                        {formatNumber(Math.round(offer.rate * 100 * 100) / 100)}%
                                    </div>
                                    <div className={'fw-offers_offercard_detail_item_title'}>Ставка</div>
                                </div>
                                <div className={'fw-offers_offercard_detail_item'}>
                                    <div
                                        className={'fw-offers_offercard_detail_value'}>{formatNumber(Math.round(offer.term / 12))} лет
                                    </div>
                                    <div className={'fw-offers_offercard_detail_item_title'}>Срок</div>
                                </div>
                                <div className={'fw-offers_offercard_detail_item'}>
                                    <div
                                        className={'fw-offers_offercard_detail_value'}>{formatNumber(Math.round(offer.monthlyPayment))} Р/мес
                                    </div>
                                    <div className={'fw-offers_offercard_detail_item_title'}>Платеж</div>
                                </div>
                            </div>
                }
            </div>
        );
    }
}


export default OfferCard;
